import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <h2 className="footer-logo">
            Salekiya<span>.</span>
          </h2>
          <p className="footer-description">
            Your neighborhood marketplace to buy, sell, and connect safely with local verified community members.
          </p>
        </div>

        <div className="footer-links-grid">
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Explore Ads</Link></li>
              <li><Link to="/post">Post an Ad</Link></li>
              <li><Link to="/my-listings">My Listings</Link></li>
              <li><Link to="/messages">Chats</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              {/* <li><Link to="/terms">Terms & Conditions</Link></li> */}
              {/* <li><Link to="/privacy">Privacy Policy</Link></li> */}
              <li><Link to="/safety">Safety Guidelines</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Help & Support</h4>
            <ul>
              <li><Link to="/faq">FAQs</Link></li>
              <li><a href="mailto:info@salekiya.com">info@salekiya.com</a></li>
              <li><span>Mon - Sat: 9 AM - 7 PM</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>&copy; {currentYear} Salekiya. All rights reserved.</p>
          <div className="footer-bottom-links">
            {/* <Link to="/privacy">Privacy</Link> */}
            {/* <span>•</span> */}
            {/* <Link to="/terms">Terms</Link> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;